import React from 'react';
import styles from './loader.module.scss';

const Loader: React.FC = () => {
  return (
      <div className={styles.loaderContainer}>
          <div className={styles.loader}>
              {Array.from(Array(12).keys()).map(i => (
                  <div key={'div' + i} />
              ))}
          </div>
      </div>
  );
}

export default Loader;
